import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  GetReportPdfPayload, PdfColorProps, ReportPdfInitialState, ReportPdfResponse1, ReportPdfResponse2,
  ReportPdfResponse3,
  ReportPdfResponse4,
} from '../types';

const initialState: ReportPdfInitialState = {
  isLoading: false,
  isPdfError1: 0,
  isPdfError2a: 0,
  isPdfError2b: 0,
  isPdfError2c: 0,
  isPdfError3: 0,
  isPdfError4: 0,
  reportPdfResponse1: {} as ReportPdfResponse1,
  reportPdfResponse2a: {} as ReportPdfResponse2,
  reportPdfResponse2b: {} as ReportPdfResponse2,
  reportPdfResponse2c: {} as ReportPdfResponse2,
  reportPdfResponse3: {} as ReportPdfResponse3,
  reportPdfResponse4: {} as ReportPdfResponse4,
  checkedSections: [],
  themePdfColor: {
    BorderColor: '#4A73FF',
    MainColor: '#C0FBAC',
  },
  tableContent: [] as string[],
};

export const reportpdfSlice = createSlice({
  name: 'reportPdf',
  initialState,
  reducers: {

    setCheckedSections(state, action:PayloadAction<string[]>) {
      return {
        ...state,
        checkedSections: action.payload,
      };
    },

    resetReportPdfState() {
      return initialState;
    },
    resetPdfData(state) {
      return {
        ...state,
        reportPdfResponse1: {} as ReportPdfResponse1,
        reportPdfResponse2a: {} as ReportPdfResponse2,
        reportPdfResponse2b: {} as ReportPdfResponse2,
        reportPdfResponse2c: {} as ReportPdfResponse2,
        reportPdfResponse3: {} as ReportPdfResponse3,
        reportPdfResponse4: {} as ReportPdfResponse4,
        isPdfError1: 0,
        isPdfError2a: 0,
        isPdfError2b: 0,
        isPdfError2c: 0,
        isPdfError3: 0,
        isPdfError4: 0,
      };
    },

    getReportPdf1Start(state, _action:PayloadAction<GetReportPdfPayload>) {
      return {
        ...state,
        isLoading: true,
      };
    },

    getReportPdf1Success(state, action:PayloadAction<ReportPdfResponse1>) {
      return {
        ...state,
        isLoading: false,
        reportPdfResponse1: action.payload,
      };
    },

    getReportPdf1Failure(state, action: PayloadAction<number>) {
      return {
        ...state,
        isLoading: false,
        isPdfError1: action.payload,
      };
    },
    getReportPdf2aStart(state, _action:PayloadAction<GetReportPdfPayload>) {
      return {
        ...state,
        isLoading: true,
      };
    },

    getReportPdf2aSuccess(state, action:PayloadAction<ReportPdfResponse2>) {
      return {
        ...state,
        isLoading: false,
        reportPdfResponse2a: action.payload,
      };
    },

    getReportPdf2aFailure(state, action: PayloadAction<number>) {
      return {
        ...state,
        isLoading: false,
        isPdfError2a: action.payload,
      };
    },
    getReportPdf2bStart(state, _action:PayloadAction<GetReportPdfPayload>) {
      return {
        ...state,
        isLoading: true,
      };
    },

    getReportPdf2bSuccess(state, action:PayloadAction<ReportPdfResponse2>) {
      return {
        ...state,
        isLoading: false,
        reportPdfResponse2b: action.payload,
      };
    },

    getReportPdf2bFailure(state, action: PayloadAction<number>) {
      return {
        ...state,
        isLoading: false,
        isPdfError2b: action.payload,
      };
    },
    getReportPdf2cStart(state, _action:PayloadAction<GetReportPdfPayload>) {
      return {
        ...state,
        isLoading: true,
      };
    },

    getReportPdf2cSuccess(state, action:PayloadAction<ReportPdfResponse2>) {
      return {
        ...state,
        isLoading: false,
        reportPdfResponse2c: action.payload,
      };
    },

    getReportPdf2cFailure(state, action: PayloadAction<number>) {
      return {
        ...state,
        isLoading: false,
        isPdfError2c: action.payload,
      };
    },

    getReportPdf3Start(state, _action:PayloadAction<GetReportPdfPayload>) {
      return {
        ...state,
        isLoading: true,
      };
    },

    getReportPdf3Success(state, action:PayloadAction<ReportPdfResponse3>) {
      return {
        ...state,
        isLoading: false,
        reportPdfResponse3: action.payload,
      };
    },

    getReportPdf3Failure(state, action: PayloadAction<number>) {
      return {
        ...state,
        isLoading: false,
        isPdfError3: action.payload,
      };
    },
    getReportPdf4Start(state, _action:PayloadAction<GetReportPdfPayload>) {
      return {
        ...state,
        isLoading: true,
      };
    },

    getReportPdf4Success(state, action:PayloadAction<ReportPdfResponse4>) {
      return {
        ...state,
        isLoading: false,
        reportPdfResponse4: action.payload,
      };
    },

    getReportPdf4Failure(state, action: PayloadAction<number>) {
      return {
        ...state,
        isLoading: false,
        isPdfError4: action.payload,
      };
    },

    setThemePdfColor(state, action:PayloadAction<PdfColorProps>) {
      return {
        ...state,
        // BorderColor: action.payload.BorderColor,
        // MainColor: action.payload.MainColor,
        themePdfColor: action.payload,
      };
    },
    setTableContent(state, action: PayloadAction<string[]>) {
      return {
        ...state,
        tableContent: action.payload,
      };
    },
  },
});

export const {
  resetReportPdfState, getReportPdf1Start, getReportPdf1Success,
  getReportPdf1Failure, getReportPdf2aStart, getReportPdf2aSuccess, getReportPdf2aFailure,
  getReportPdf2bStart, getReportPdf2bSuccess, getReportPdf2bFailure,
  getReportPdf2cStart, getReportPdf2cSuccess, getReportPdf2cFailure,
  getReportPdf3Start, getReportPdf3Success, getReportPdf3Failure, getReportPdf4Start,
  getReportPdf4Success, getReportPdf4Failure, setCheckedSections, setThemePdfColor,
  setTableContent, resetPdfData,
} = reportpdfSlice.actions;
export const reportPdfSliceReducer = reportpdfSlice.reducer;

export type ReportPdfActions =
  | ReturnType<typeof resetReportPdfState>
  | ReturnType<typeof getReportPdf1Start>
  | ReturnType<typeof getReportPdf1Success>
  | ReturnType<typeof getReportPdf1Failure>
  | ReturnType<typeof getReportPdf2aStart>
  | ReturnType<typeof getReportPdf2aSuccess>
  | ReturnType<typeof getReportPdf2aFailure>
  | ReturnType<typeof getReportPdf2bStart>
  | ReturnType<typeof getReportPdf2bSuccess>
  | ReturnType<typeof getReportPdf2bFailure>
  | ReturnType<typeof getReportPdf2cStart>
  | ReturnType<typeof getReportPdf2cSuccess>
  | ReturnType<typeof getReportPdf2cFailure>
  | ReturnType<typeof getReportPdf3Start>
  | ReturnType<typeof getReportPdf3Success>
  | ReturnType<typeof getReportPdf3Failure>
  | ReturnType<typeof getReportPdf4Start>
  | ReturnType<typeof getReportPdf4Success>
  | ReturnType<typeof getReportPdf4Failure>
  | ReturnType<typeof setCheckedSections>
  | ReturnType<typeof setThemePdfColor>
  | ReturnType<typeof setTableContent>
  | ReturnType<typeof resetPdfData>;
